import React, { createContext, useContext, useEffect, useState } from "react";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { db } from "./firebaseConfig";

export interface MemberType {
    uid: string;
    name: string;
    phone: string;
    deleted: boolean;
    bankAccount: any[];
    savedKiosk: any[];
    timestamp: number;
    partnerId: string;
}

interface MemberContextType {
    members: MemberType[];
}

const MemberContext = createContext<MemberContextType | null>(null);

export const MemberProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
    const partnerId = sessionStorage.getItem("partnerId");
    const [members, setMembers] = useState<MemberType[]>([]);

    useEffect(() => {
        if (!partnerId) return; // partnerId가 없으면 데이터 조회하지 않음

        const unsubscribe = onSnapshot(
            query(collection(db, "member"), where("partnerId", "==", partnerId)),
            async (snapshot) => {
                const membersLists = snapshot.docs
                    .map((doc) => doc.data() as MemberType)
                    .sort((a, b) => {
                        if (a.timestamp && b.timestamp) return a.timestamp - b.timestamp;
                        else return 0;
                    });
                setMembers(membersLists);
            }
        );

        return () => unsubscribe();
    }, [partnerId]); // partnerId 의존성 추가

    return <MemberContext.Provider value={{ members }}>{children}</MemberContext.Provider>;
};

export const useMember = (): MemberContextType => {
    const context = useContext(MemberContext);
    if (!context) {
        throw new Error("usePoint must be used within a PointProvider");
    }
    return context;
};
